import React from 'react';
import { useGlobal } from '@rcg/ui-react';
import { Typography } from '@rcg/ui-react/lib/components';
import clsx from 'clsx';
import useStyles from './useStyles';
import Dictionary from '../../utils/dictionary';

const ResultsFail = ({ className }) => {
  const classes = useStyles();
  const { renderContent } = useGlobal();
  return (
    <div className={classes.noResultsContainer}>
      <div className={clsx(classes.noResultsSection, className)}>
        <Typography variant="h5" className={classes.noResultsHeader}>
          {renderContent(
            Dictionary.airNoResultsTitle.key,
            Dictionary.airNoResultsTitle.defaultValue,
          )}
        </Typography>
        <Typography variant="subtitle1" className={classes.noResultsDescription}>
          {renderContent(
            Dictionary.airNoResultsDescription.key,
            Dictionary.airNoResultsDescription.defaultValue,
          )}
        </Typography>
      </div>
    </div>
  );
};
export default ResultsFail;
